import { render, staticRenderFns } from "./Parceria_Sindimei.vue?vue&type=template&id=3083de1e"
import script from "./Parceria_Sindimei.vue?vue&type=script&lang=js"
export * from "./Parceria_Sindimei.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sindimei.vue?vue&type=style&index=0&id=3083de1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports